import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
    selector: 'app-footer-client',
    standalone: true,
    imports: [],
    templateUrl: './footer-client.component.html',
    styleUrl: './footer-client.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterClientComponent {}
